var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isOnboarding)?_c('AnnouncementOnboarding',{attrs:{"page-content":_vm.pageContent},on:{"go-to-next-step":_vm.goToNextStep}}):_c('AnnouncementAuthentication',{attrs:{"page-content":_vm.pageContent},on:{"go-back-event":_vm.goBackEvent,"go-to-help-center":_vm.goToHelpCenter,"go-to-next-step":_vm.goToNextStep}})
}
var staticRenderFns = []

export { render, staticRenderFns }